import { render, staticRenderFns } from "./MobileChat.vue?vue&type=template&id=e8e7a164&scoped=true&"
import script from "./MobileChat.vue?vue&type=script&lang=js&"
export * from "./MobileChat.vue?vue&type=script&lang=js&"
import style0 from "./MobileChat.vue?vue&type=style&index=0&id=e8e7a164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e7a164",
  null
  
)

export default component.exports